// frontend/src/motion/rafThrottle.js
//
// Coalesce a burst of events into ONE call on the next animation frame.
//
// `resize` fires per pixel while a window edge is dragged, and every consumer
// on the homepage answers it by measuring layout (the headline fit, the mobile
// flag) or by re-sizing a canvas backing store (the mesh, the smoke). Running
// those per event is a forced reflow, or a canvas reallocation, per pixel.
//
// A PLAIN requestAnimationFrame, deliberately not a rafCoordinator task: the
// handlers this throttles are layout, not decoration, and they must keep
// working with motion off - when the coordinator holds no chain at all.
//
// This is the `onScroll` shape ScannedTray and HowItWorksLive use inline; it
// was HeroLive's private helper until the perf batch (2026-09-04) gave the two
// canvases the same protection.

/**
 * @param {() => void} fn
 * @returns {{ handler: () => void, cancel: () => void }} `handler` is the
 *   listener to register; `cancel` drops a pending frame (call it on cleanup).
 */
export default function rafThrottle(fn) {
  let frame = 0;
  const handler = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      fn();
    });
  };
  const cancel = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
  };
  return { handler, cancel };
}

export { rafThrottle };
